import * as React from 'react';
const SettingsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill={props.color}
        d="M1.339 15.518a2.5 2.5 0 0 0 3.414.918l.002-.002.371-.214A7.48 7.48 0 0 0 7.5 17.59v.428a2.5 2.5 0 0 0 5 0v-.428a7.482 7.482 0 0 0 2.373-1.372l.372.215a2.501 2.501 0 1 0 2.5-4.333l-.37-.213a7.582 7.582 0 0 0 0-2.742l.37-.213a2.501 2.501 0 0 0-2.5-4.334l-.37.215A7.481 7.481 0 0 0 12.5 3.445v-.427a2.5 2.5 0 0 0-5 0v.427a7.48 7.48 0 0 0-2.374 1.372L4.754 4.6a2.501 2.501 0 1 0-2.5 4.333l.37.214a7.584 7.584 0 0 0 0 2.741l-.37.214a2.505 2.505 0 0 0-.915 3.415Zm8.66-8.334a3.333 3.333 0 1 1 0 6.667 3.333 3.333 0 0 1 0-6.667Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .518h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SettingsIcon;
